import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { TypographyColor, TypographyFontFamily } from '@design-system/components/atoms/typography/entities/typography.types';
import {
  AlertAlign, AlertProps, AlertSize, AlertSizeProps, AlertType
} from '@design-system/components/molecules/alert/entities/alert.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
  ]
})
export class AlertDsComponent {

  @Input() type = AlertType.Default;
  @Input() size = AlertSize.XS;
  @Input() align = AlertAlign.Top;
  @Input() message: string;
  @Input() icon: Icon = null;

  constructor() { }

  get alerProps(): AlertProps {
    return AlertSizeProps?.[this.size];
  }

  get primaryTextColor(): TypographyColor {
    switch (this.type) {
      case AlertType.Warning:
        return TypographyColor.Warning;
      case AlertType.Error:
        return TypographyColor.Error;
      default:
        return TypographyColor.Primary;
    }
  }

  get iconColor(): IconFillColor {
    switch (this.type) {
      case AlertType.Warning:
        return IconFillColor.Warning;
      case AlertType.Error:
        return IconFillColor.Error;
      case AlertType.Confirmed:
        return IconFillColor.Confirmed;
      default:
        return IconFillColor.Primary;
    }
  }

  get messageFontFamily(): TypographyFontFamily {
    return this.type === AlertType.Confirmed ? TypographyFontFamily.SemiBold : TypographyFontFamily.Regular;
  }

}
